import { useRootState } from '../../store/hooks/useRootState';
import { CompanyCmd } from './companyCmd.types';

export const useCompanyCmd = (): CompanyCmd => {
  return useRootState().companyCmd.cmd;
};

export const useCompanyCmdDevicesDict = (): Record<string, CompanyCmd | undefined> => {
  return Object.fromEntries(useRootState().companyCmd.devices.map(x => [x.serial, x.cmd]));
};
